import {
  STYLES,
  TEMPLATE_VARS_CLOSING,
  TEMPLATE_VARS_OPENING,
  TEMPLATE_VARS_REVERSE_MAPPING,
} from './constants';

export const splitString = (text) => {
  // renders message = 'Hello world <h><url>https://www.google.com<url><style><fs>16<fs><style>some text<h> end of text',
  // Hello world some text end of text
  // with the font size of some text being 16px and href = https://www.google.com

  const segments = [];
  let normalString = '';

  for (let i = 0; i < text.length; i++) {
    const nextIndex = i + 1;
    // support variable placeholders like {{1}} — emit as VARIABLE segments
    if (text.substring(i, i + 2) === '{{') {
      if (normalString.length > 0) {
        segments.push({ value: normalString, type: STYLES.NORMAL });
        normalString = '';
      }
      i += 2; // skip opening '{{'
      let varString = '';
      while (i < text.length && text.substring(i, i + 2) !== '}}') {
        varString += text[i];
        i++;
      }
      segments.push({ value: varString.trim(), type: STYLES.VARIABLE });
      i += 1; // position at closing '}}' (loop will i++ to move past)
      continue;
    }
    // support single-brace placeholders like {1} as an alternative
    if (text[i] === '{' && text.substring(i, i + 2) !== '{{') {
      if (normalString.length > 0) {
        segments.push({ value: normalString, type: STYLES.NORMAL });
        normalString = '';
      }
      i += 1; // skip opening '{'
      let varString = '';
      while (i < text.length && text[i] !== '}') {
        varString += text[i];
        i++;
      }
      // if we reached a closing brace, consume it; otherwise treat as normal text
      if (i < text.length && text[i] === '}') {
        segments.push({ value: varString.trim(), type: STYLES.VARIABLE });
      } else {
        // unmatched '{', treat literally
        normalString += '{' + varString;
      }
      continue;
    }
    for (let templateVarKey of Object.keys(TEMPLATE_VARS_OPENING)) {
      const templateVar = TEMPLATE_VARS_OPENING[templateVarKey];
      const templateVarLength = templateVar.length;
      if (text.substring(i, i + templateVarLength) === templateVar) {
        if (normalString.length > 0) {
          segments.push({ value: normalString, type: STYLES.NORMAL });
          normalString = '';
        }
        i += templateVarLength;
        let templateString = '';
        let currOpeningTemplateVarCount = 1;
        while (
          i < text.length &&
          (text.substring(i, i + TEMPLATE_VARS_CLOSING[templateVar].length) !==
            TEMPLATE_VARS_CLOSING[templateVar] ||
            currOpeningTemplateVarCount > 1)
        ) {
          if (text.substring(i, i + templateVarLength) === templateVar) {
            currOpeningTemplateVarCount++;
          }
          if (
            text.substring(i, i + TEMPLATE_VARS_CLOSING[templateVar].length) ===
            TEMPLATE_VARS_CLOSING[templateVar]
          ) {
            currOpeningTemplateVarCount--;
          }
          if (currOpeningTemplateVarCount === 0) {
            break;
          }
          templateString += text[i];
          i++;
        }

        segments.push({
          children: splitString(templateString),
          type: TEMPLATE_VARS_REVERSE_MAPPING[templateVar],
        });
        i += TEMPLATE_VARS_CLOSING[templateVar].length - 1;
        break;
      }
    }
    if (i + 1 === nextIndex) {
      normalString += text[i];
    }
  }

  if (normalString.length) {
    segments.push({ value: normalString, type: STYLES.NORMAL });
  }

  return segments;
};
